module.exports = {
    API_URL: 'https://abiturient.edus.kz/',
    API_VERSION: 'v1',
}